<div [@fadeInFadeOut]>
  <svg *ngIf="!text" class="spinner spinner-image" source="assets/media/blue_spinner.svg"></svg>
  <p *ngIf="text" class="spinner spinner-text">{{text}}</p>
  <div class="spinner-overlay"></div>
</div>
